/**
 * Type of default actions supported by metrics
 *
 * @module ActionTypes
 * @internal
 */
enum ActionTypes {
  PAGE_VIEW = 'pageView', // request page view track
  TRACK = 'track', // request custom link track
  IDENTIFY = 'identify', // add identity to tracking layer
}

/**
 * Type of track events that can be sent
 *
 * @module EventTypes
 * @internal
 */
enum EventTypes {
  PAGE_VIEW_EVENT = 'pageLoad',
  IDENTIFY = 'identify',
  CUSTOM_ACTION = 'custom_action',
  ENTRY_POINT = 'entry_point',

  NEWSLETTER_SIGNUP = 'newsletter_signup',
  SPONTANEITY_SIGNUP = 'spontaneity_signup',
  FOLLOW_STORY = 'follow_story',
  CONTACT_PHONE = 'contact_phone',
  CONTACT_WHATSAPP = 'contact_whatsapp',

  PRODUCT_DETAILS_PAGE = 'product_details_page',
  ADD_TO_CART = 'add_to_cart',
  CHECKOUT_STEP_EXTRA = 'checkout_step_extra',
  CHECKOUT_STEP_DATA = 'checkout_step_data',
  CHECKOUT_STEP_SUMMARY = 'checkout_step_summary',
  CHECKOUT_STEP_PAYMENT = 'begin_checkout',
  PURCHASE = 'purchase',

  GIFTCARD_ADD_TO_CART = 'giftcard_add_to_cart',
  GIFTCARD_PURCHASE = 'giftcard_purchase',

  AROUND_THE_WORLD_ENTER = 'around_the_world_enter',
}

export { ActionTypes, EventTypes }
